import React from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import CommunityEditor from './EditorPages/CommunityEditor';
import CommunityResults from './ResultsPages/CommunityResults';

function Communities({
    urlParams
}) {
    const queryParams = queryString.parse(urlParams);

    return (
        queryParams && queryParams['id'] ?
            <CommunityEditor id={queryParams['id']} /> :
            <CommunityResults />
    );
}

const mapStateToProps = (state) => ({
    urlParams: state.router.location.search,
});

export default connect(mapStateToProps, null)(Communities);